import dynaForms from '@elab/core/utils/dynaForms';

export const storeName = 'share-wishlist';

export default {
    ...dynaForms.getTypes(storeName),
    SET_VERIFICATION_STATE: `${storeName}.SET_VERIFICATION_STATE`,
    SET_SHARE_EMAIL_ID: `${storeName}.SET_SHARE_EMAIL_ID`,
};
